import { useView } from "aurelia-framework";

@useView('views/pages/modules/auto-screening/templates/pre-arrival-risk-review/tabs/definitions/pre-arrival-risk-review-definitions.html')
export class PreArrivalRiskReviewDefinitions {

}
